import React from 'react';
import { Helmet } from 'react-helmet';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { useLanguage } from '@/hooks/useLanguage';

const Imprint = () => {
  const { language } = useLanguage();

  return (
    <>
      <Helmet>
        <title>{language === 'de' ? 'Impressum' : 'Imprint'} | Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin</title>
        <meta name="description" content={language === 'de'
          ? 'Impressum der Website von Matthias Meyfarth aus Berlin – rechtliche Angaben gemäß §5 TMG.'
          : 'Imprint of the website of Matthias Meyfarth from Berlin – legal information according to §5 TMG.'} />
        <meta property="og:title" content={language === 'de'
          ? 'Impressum | Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin'
          : 'Imprint | Matthias Meyfarth – Videograf, Fotograf & Webdesigner from Berlin'} />
        <meta property="og:description" content={language === 'de'
          ? 'Rechtliche Informationen über Matthias Meyfarth, Videograf, Fotograf und Webdesigner aus Berlin.'
          : 'Legal information about Matthias Meyfarth, videographer, photographer and web designer from Berlin.'} />
        <meta property="og:type" content="website" />
      </Helmet>

      <Navigation />

      <main className="container mx-auto px-6 py-24">
        <h1 className="text-4xl font-bold mb-8">
          {language === 'de' ? 'Impressum' : 'Imprint'}
        </h1>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">
            {language === 'de' ? 'Angaben gemäß § 5 TMG' : 'Information according to § 5 TMG'}
          </h2>

          <p className="mb-4">
            Matthias Meyfarth<br />
            Videograf, Fotograf & Webdesigner<br />
            Berlin, Deutschland
          </p>

          <p className="mb-4">
            {language === 'de' ? 'Kontakt:' : 'Contact:'}<br />
            E-Mail: deine@email.de
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">
            {language === 'de' ? 'Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV' : 'Responsible for content according to § 55 paragraph 2 RStV'}
          </h2>

          <p className="mb-4">
            Matthias Meyfarth<br />
            Berlin, Deutschland
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">
            {language === 'de' ? 'Haftungsausschluss' : 'Disclaimer'}
          </h2>

          <p className="mb-4">
            {language === 'de'
              ? 'Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.'
              : 'Despite careful content control, we assume no liability for the content of external links. The operators of the linked pages are solely responsible for their content.'}
          </p>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Imprint;
